export default __webpack_public_path__ + "static/media/icon-business-model-service.9c256003.svg";